'use client';

import { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'next/navigation';
import { useLoginModals } from '../Login/common/LoginModalsManager';

/**
 * Client component that detects resetToken in URL and opens the reset password modal
 * Keeps the token in the URL
 */
export function ResetPasswordTokenHandler() {
  const searchParams = useSearchParams();
  const loginModals = useLoginModals();
  const [mounted, setMounted] = useState(false);
  const hasOpenedModalRef = useRef(false);

  // Ensure component is mounted (client-side only)
  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    // Only run on client side after mount
    if (!mounted) return;
    
    const resetToken = searchParams?.get('resetToken');
    
    // Only open modal once per token
    if (resetToken && !hasOpenedModalRef.current) {
      hasOpenedModalRef.current = true;
      
      // Open the reset password modal with token immediately
      loginModals.openResetPasswordWithTokenModal(resetToken);
    }
  }, [searchParams, loginModals, mounted]);

  return null;
}
